//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";

export default {
    name: "EnableAI",
    components: {
        AQButton,
        AQModal,
        AQInput,
        AQDialog,
        AQCard,
        AQDropdown
    },
    props: {
        value: {
            type: Object,
            default: () => {}
        },
        extraData: {
            type: Object,
            default: () => {}
        },
        isInEdit: { type: Boolean, default: false },
        dataObjectEnableAI: {
            type: Object,
            default: () => {}
        }

    },
    data() {
        return {
            showConfigurationModal: false,
            apiKey: "",
            apiKeyAzure: "",
            showDialog: false,
            URL: "https://api.openai.com",
            URLAzure: "",
            chatName: "",
            embeddingName: "",
            noKeyFound: false,
            noURLFound: false,
            noAzureKeyFound: false,
            noAzureURLFound: false,
            noChatNameFound: false,
            noEmbeddingNameFound: false,
            isInEditLocal: this.isInEdit,
            apiSelection: "",
            defaultSelectedApi: "OPENAI",
            typeOptions: [
                {
                    label: "OpenAI",
                    value: "OPENAI"
                },
                {
                    label: "Azure OpenAI",
                    value: "AZUREOPENAI"
                }
            ]
        };
    },
    computed: {
        setButtonlabel() {
            return this.isInEditLocal ? this.$t("admin.labs.editConfiguration") : this.$t("admin.labs.configure");
        },
        setConfigurelabel() {
            return this.isInEditLocal ? this.$t("admin.labs.configured") : this.$t("admin.labs.noAIConfiguration");
        },
        hasDone() {
            return {
                label: this.$t("generic.done")
            };
        }
    },
    methods: {
        openConfigurationModal() {
            const data = this.dataObjectEnableAI && Object.keys(this.dataObjectEnableAI).length ? this.dataObjectEnableAI : (this.extraData || {});
            const isOAI = data && data.aiProvider ? data.aiProvider === "OAI" : true;
            this.defaultSelectedApi = isOAI ? "OPENAI" : "AZUREOPENAI";
            if (isOAI) {
                this.URL = data.aiUrl || "https://api.openai.com";
                this.apiKey = data.aiApiKey || "";
            } else {
                this.URLAzure = data.aiUrl || "";
                this.apiKeyAzure = data.aiApiKey || "";
                this.chatName = data.chatDeploymentName || "";
                this.embeddingName = data.embeddingDeploymentName || "";
            }
            this.showConfigurationModal = true;
        },
        selectAI() {
            this.apiKey = "";
            this.apiKeyAzure = "";
            this.URL = "https://api.openai.com";
            this.URLAzure = "";
            this.chatName = "";
            this.embeddingName = "";
        },
        actionsDlg($event) {
            if ($event === "close") {
                const { aiApiKey = "", aiUrl = "", aiProvider = this.apiSelection === "OPENAI" ? "OAI" : "AOAI",
                    chatDeploymentName = "", embeddingDeploymentName = "" } = this.dataObjectEnableAI
                && Object.keys(this.dataObjectEnableAI).length ? this.dataObjectEnableAI : (this.extraData || {});
                const isOAIProvider = aiProvider === "OAI" && (
                    (aiApiKey && aiUrl && (this.apiKey !== aiApiKey || this.URL !== aiUrl))
                    || (!aiApiKey && !aiUrl && (this.apiKey || this.URL !== "https://api.openai.com"))
                );

                const isAOAIProvider = aiProvider === "AOAI" && (
                    (aiApiKey && aiUrl && chatDeploymentName && embeddingDeploymentName
                        && (this.apiKeyAzure !== aiApiKey || this.URLAzure !== aiUrl || this.chatName !== chatDeploymentName
                        || this.embeddingName !== embeddingDeploymentName))
                        || (!aiApiKey && !aiUrl && !chatDeploymentName && !embeddingDeploymentName
                        && (this.apiKeyAzure || this.URLAzure || this.chatName || this.embeddingName))
                );
                if (isOAIProvider || isAOAIProvider) {
                    this.showDialog = true;
                } else {
                    if (this.apiSelection === "OPENAI") {
                        this.noKeyFound = false;
                        this.noURLFound = false;
                    } else {
                        this.noAzureKeyFound = false;
                        this.noAzureURLFound = false;
                        this.noChatNameFound = false;
                        this.noEmbeddingNameFound = false;
                    }
                    this.showConfigurationModal = false;
                }
            } else if ($event === "primary") {
                if (this.apiSelection === "OPENAI") {
                    this.noKeyFound = !this.apiKey;
                    this.noURLFound = !this.URL;
                } else {
                    this.noAzureKeyFound = !this.apiKeyAzure;
                    this.noAzureURLFound = !this.URLAzure;
                    this.noChatNameFound = !this.chatName;
                    this.noEmbeddingNameFound = !this.embeddingName;
                }
                if ((this.apiSelection === "OPENAI" && this.apiKey && this.URL)
                    || (this.apiSelection !== "OPENAI" && this.apiKeyAzure && this.URLAzure && this.chatName && this.embeddingName)) {
                    this.showConfigurationModal = false;
                    const configurationObj = {
                        apiKey: this.apiSelection === "OPENAI" ? this.apiKey : this.apiKeyAzure,
                        url: this.apiSelection === "OPENAI" ? this.URL : this.URLAzure,
                        aiProvider: this.apiSelection === "OPENAI" ? "OAI" : "AOAI"
                    };
                    if (this.apiSelection !== "OPENAI") {
                        configurationObj.chatDeploymentName = this.chatName;
                        configurationObj.embeddingDeploymentName = this.embeddingName;
                    }
                    this.isInEditLocal = true;
                    this.$emit("configurationDetails", { payload: configurationObj, target: "dataObjectEnableAI" });
                }
            }
        },
        okAction() {
            this.showConfigurationModal = false;
            const data = this.extraData || this.dataObjectEnableAI;
            const isOAI = this.apiSelection === "OPENAI";

            if (isOAI) {
                this.URL = data.aiUrl || "https://api.openai.com";
                this.apiKey = data.aiApiKey || "";
            } else {
                this.URLAzure = data.aiUrl;
                this.apiKeyAzure = data.aiApiKey;
                this.chatName = data.aiChatName;
                this.embeddingName = data.aiEmbeddingName;
            }
            this.noKeyFound = false;
            this.noURLFound = false;
            this.noAzureKeyFound = false;
            this.noAzureURLFound = false;
            this.noChatNameFound = false;
            this.noEmbeddingNameFound = false;
        },
        cancelAction() {
            this.showDialog = false;
        },
        checkValue() {
            if (this.apiKey) {
                this.noKeyFound = false;
            }
            if (this.URL) {
                this.noURLFound = false;
            }
        }
    }
};
